import { defineMessages } from 'react-intl';

export default defineMessages({
    policyCoverages: {
        id: 'wmic-pe-capability-policy-common-react.PAPolicyLevelCoverages.Policy Level Coverages',
        defaultMessage: 'Policy Level Coverages',
    },
    liabilityProtectionPhysicalDamage: {
        id: 'wmic-pe-capability-policy-common-react.PAPolicyLevelCoverages.Liability Protection Physical Damage same as',
        defaultMessage: 'Liability Protection, Physical Damage same as',
    },
});
